@import 'apps/webcomponents/src/assets/fonts.scss';
@import 'apps/webcomponents/src/assets/style-helpers.scss';

:host {
  box-sizing: border-box;
  font-family: var(--font-family);
}

gz-chips-generator-input {
  --chip-list-width: 600px;
  --form-field-with-floating-max-width: 100%;
}

gz-form-field {
  --form-field-label-width: 270px;
}

.container {
  max-width: 886px;
  margin: calc(4 * var(--spacer)) 0 calc(6 * var(--spacer)) calc(5 * var(--spacer));
}

.title-container {
  height: calc(4 * var(--spacer));
  margin-bottom: calc(2 * var(--spacer));
}

.field-container {
  height: calc(4 * var(--spacer));
  margin-bottom: var(--spacer);
}

.scan-name-input {
  width: 600px;
  min-width: 600px;
}

.action-buttons {
  padding: calc(1.5 * var(--spacer)) calc(5 * var(--spacer));
  display: flex;
  justify-content: space-between;
  background-color: var(--white-layout-300-primary);
  border-top: 1px solid var(--chart-050-hover);
}
